export default function useLoginWithRedirectCypress() {
  return () => {
    // No-op for Cypress tests
  };
}
